export default "__VITE_ASSET__BdtpD2Gi__"